import React, { Component } from "react";
import { Modal, Form, Input, Row, Spin } from "antd";
import { observer } from "mobx-react";

const FormItem = Form.Item;

@Form.create({})
@observer
class AddAccountProfileDialog extends Component {
	addAccountProfile = () => {
		this.props.form.validateFields((err, changedFields) => {
			if (err) {
				return;
			}
			let name = this.props.form.getFieldValue("name");
			this.props.addAccountProfile({
				name: name
			});
			this.props.form.resetFields();
		});
	};

	hideDialog = () => {
		this.props.form.resetFields();
		this.props.hideDialog();
	};

	render() {
		const {
			ui: { addAccountProfileDialogVisible, addingAccountProfile },
			hideDialog,
			form
		} = this.props;
		return (
			<Modal
				visible={addAccountProfileDialogVisible}
				title="New Account Profile"
				okText="Create"
				onCancel={this.hideDialog}
				onOk={this.addAccountProfile}
			>
				<Spin spinning={addingAccountProfile == true}>
					<FormItem
						labelCol={{ span: 5 }}
						wrapperCol={{ span: 15 }}
						label="Name"
					>
						{form.getFieldDecorator("name", {
							rules: [
								{
									required: true,
									message: "Please enter account store name"
								}
							]
						})(<Input placeholder="My great SEO accounts" />)}
					</FormItem>
				</Spin>
			</Modal>
		);
	}
}

export default AddAccountProfileDialog;
